angular.module('bmsApp.employeeAttendanceRecord').controller('EmployeeAttendanceCtrl', [
	'$scope',
	'$q',
	'$timeout',
	'notify',
	'EmployeeOptionsSvc',
	'EmployeeHolidaySvc',
	'EmployeeAttendanceRecordSvc', function ($scope,
											 $q,
											 $timeout,
											 notify,
											 EmployeeOptionsSvc,
											 EmployeeHolidaySvc,
											 EmployeeAttendanceRecordSvc) {

		$scope.formvalidatorconfig = {
			submitHandler: function () {
				$scope.submitForm($scope.employee_attendance_records);
			}
		};

		$scope.timePickerOptions = angular.copy($scope.config.uiTimepickerOptions);
		$scope.timePickerOptions.step = 5;

		var ctrl = {
			init: function () {
				$scope.loading = true;
				$scope.processing = false;
				$scope.attendanceFilter = {
					date: moment().format($scope.config.datePicker.basic.storageFormat),
					employee: null
				};

				$scope.attendanceTimepickerConfig = angular.extend(angular.copy($scope.config.uiTimepickerOptions), {
					minTime: '09:00'
				});

				$scope.$watch(function () {
					return $scope.attendanceFilter;
				}, function () {
					ctrl.loadEmployeeAttendanceRecords();
				}, true);
			},
			parseAttendanceConfig: function () {
				ctrl.attendanceConfig = {
					params: {
						date: null
					}
				};
				// parse date
				var date = moment($scope.attendanceFilter.date);
				if (date.isValid()) {
					ctrl.attendanceConfig.params.date = date.format('YYYY-MM-DD');
				}
				else {
					console.log('Invalid date selection');
				}
				if ($scope.attendanceFilter.employee) {
					ctrl.attendanceConfig.params.employee_id = $scope.attendanceFilter.employee.id;
				}
			},
			loadEmployeeAttendanceRecords: function () {
				ctrl.parseAttendanceConfig();
				$scope.loading = true;
				$scope.employee_attendance_records = [];
				var promises = [
					EmployeeOptionsSvc.employee(),
					EmployeeAttendanceRecordSvc.unfilledDateOptions(),
					EmployeeAttendanceRecordSvc.employeeNonAttendanceReasonOptions(),
					EmployeeAttendanceRecordSvc.date(ctrl.attendanceConfig.params),
				];
				let allEmployeesCalendarParams = {
					activeEmployee: true
				};
				if (ctrl.attendanceConfig.params.date) {
					allEmployeesCalendarParams.start = ctrl.attendanceConfig.params.date;
					allEmployeesCalendarParams.end = ctrl.attendanceConfig.params.date + ' 23:59:59';
				}
				promises.push(EmployeeHolidaySvc.allEmployeesCalendar(allEmployeesCalendarParams));
				$q.all(promises).then(function (responses) {
					$scope.employeeOptions = responses[0].data.options;
					$scope.unfilledDateOptions = responses[1].data.options;
					$scope.employeeNonAttendanceReasonOptions = responses[2].data.options;
					$scope.employees = responses[3].data.employees;
					$scope.employeeHolidays = responses[4].data.employee_holidays;
					var filledCount = 0;
					// add dummy attendance record for those not created yet
					angular.forEach($scope.employees, function (employee) {
						var employee_attendance_record;
						if (typeof employee.employee_attendance_records[0] === 'undefined') {
							let found = false;
							let holidayEmployee = null;
							angular.forEach($scope.employeeHolidays, function(holiday) {
								if (holiday.employee.id === employee.id) {
									found = true;
									holidayEmployee = holiday;
								}
							});
							if (angular.isObject(holidayEmployee)) {
								employee_attendance_record = {
									id: null,
									employee_id: employee.id,
									employee_worked: 0,
									employee_travel_rate: employee.travel_rate,
									time_in: null,
									time_out: null,
									date: ctrl.attendanceConfig.params.date,
									employee_non_attendance_reason: {
										id: 4,
									},
									work_logs: angular.copy(employee.work_logs),
								};
							}
							else {
								employee_attendance_record = {
									id: null,
									employee_id: employee.id,
									employee_worked: 1,
									employee_travel_rate: employee.travel_rate,
									time_in: null,
									time_out: null,
									date: ctrl.attendanceConfig.params.date,
									work_logs: angular.copy(employee.work_logs),
								};
							}
						}
						else {
							employee_attendance_record = angular.copy(employee.employee_attendance_records[0]);
							employee_attendance_record.time_in = moment(employee_attendance_record.time_in, "HH:mm:ss");
							employee_attendance_record.time_out = moment(employee_attendance_record.time_out, "HH:mm:ss");
							employee_attendance_record.work_logs = angular.copy(employee.work_logs);
							filledCount += 1;
						}
						$scope.filledCount = filledCount;
						employee_attendance_record.employee = angular.copy(employee);
						$timeout(function () {
							$scope.$apply(function () {
								$scope.employee_attendance_records.push(employee_attendance_record);
							});
						}, 0);
					});
					$scope.loading = false;
				});
			}

		};

		$scope.timeInChanged = function (record) {
			if (!angular.isObject(record.time_out)) {
				record.time_out = moment(record.time_in).add(1, 'h');
			}
		};

		$scope.employeeNonAttendanceReasonSelected = function (employee_non_attendance_reason, employee_attendance_record) {
			if (typeof employee_non_attendance_reason === 'undefined') {
				employee_attendance_record.employee_worked = 1;
			}
			else {
				employee_attendance_record.employee_worked = 0;
			}
		};

		$scope.submitForm = function (employee_attendance_records) {
			$scope.processing = true;
			var failed = false;
			var employeeAttendanceRecords = angular.copy(employee_attendance_records);
			angular.forEach(employeeAttendanceRecords, function (record) {
				var time_in, time_out;
				if (angular.isObject(record.time_in)) {
					record.time_in = moment(record.time_in).format("HH:mm:ss");
					time_in = moment(record.time_in, "HH:mm");
				}
				if (angular.isObject(record.time_out)) {
					record.time_out = moment(record.time_out).format("HH:mm:ss");
					time_out = moment(record.time_out, "HH:mm");
				}

				if (angular.isDefined(time_out)) {
					if (time_out.isBefore(time_in)) {
						failed = true;
					}
				}

			});

			if (failed) {
				notify({
					message: 'ERROR: One or more records has an end time before the start time'
				});
				$scope.processing = false;
				return;
			}

			var employee_attendance_records_params = {
				employee_attendance_records: employeeAttendanceRecords
			};

			EmployeeAttendanceRecordSvc.dateSave(employee_attendance_records_params)
				.then(function () {
					ctrl.loadEmployeeAttendanceRecords();
					notify({
						message: 'Attendance records saved successfully'
					});
				}, function (error) {
					notify({
						message: error,
						classes: 'error'
					});
				})
				.finally(function () {
					$scope.processing = false;
				});
		};

		$scope.timeDisabled = function (employeeAttendanceRecord) {
			if (angular.isObject(employeeAttendanceRecord.employee_non_attendance_reason)) {
				// disable if not one of the timed attendance statuses
				if ($scope.isMM()) {
					if ($scope.config.timedAttendanceStatuses.mm.indexOf(employeeAttendanceRecord.employee_non_attendance_reason.id) === -1) {
						employeeAttendanceRecord.time_in = null;
						employeeAttendanceRecord.time_out = null;
						return true;
					}
				}
				else if ($scope.isTG()) {
					if ($scope.config.timedAttendanceStatuses.tg.indexOf(employeeAttendanceRecord.employee_non_attendance_reason.id) === -1) {
						employeeAttendanceRecord.time_in = null;
						employeeAttendanceRecord.time_out = null;
						return true;
					}
				}
			}
			return false;
		};

		$scope.checkTimeRequired = function (employeeAttendanceRecord) {
			return $scope.timeDisabled(employeeAttendanceRecord) === false && employeeAttendanceRecord.employee_non_attendance_reason;
		};

		ctrl.init();

	}]);
